import { LocationProvider, Router, Route } from 'preact-iso';
import { AuthProvider } from './hooks/useAuth.jsx';
import { RequireAuth } from './components/RequireAuth.jsx';
import { Layout } from './components/Layout.jsx';
import { LoginPage } from './modules/login/LoginPage.jsx';
import { LauncherPage } from './modules/launcher/LauncherPage.jsx';
import { InkBooksIndexPage } from './modules/ink-books/InkBooksIndexPage.jsx';
import { BookDetailPage } from './modules/ink-books/BookDetailPage.jsx';
import { InkDetailPage } from './modules/ink-books/InkDetailPage.jsx';
import { ConverterPage } from './modules/converter/ConverterPage.jsx';
import { PrintersIndexPage } from './modules/printers/PrintersIndexPage.jsx';
import { PrinterDetailPage } from './modules/printers/PrinterDetailPage.jsx';
import { EquipmentPage } from './modules/equipment/EquipmentPage.jsx';
import { MachinesPage } from './modules/machines/MachinesPage.jsx';
import { InventoryIndexPage } from './modules/inventory/InventoryIndexPage.jsx';
import { InventoryItemDetailPage } from './modules/inventory/InventoryItemDetailPage.jsx';
import { MaintenanceIndexPage } from './modules/maintenance/MaintenanceIndexPage.jsx';
import { IssueDetailPage } from './modules/maintenance/IssueDetailPage.jsx';
import { EventDetailPage } from './modules/maintenance/EventDetailPage.jsx';
import { ContactsPage } from './modules/contacts/ContactsPage.jsx';
import { StatisticsPage } from './modules/statistics/StatisticsPage.jsx';
import { CustomerProfilesPage } from './modules/customer-profiles/CustomerProfilesPage.jsx';
import { CustomersPage } from './modules/customers/CustomersPage.jsx';
import { InkDensityIndexPage } from './modules/ink-density/InkDensityIndexPage.jsx';
import { InkDensityReadingPage } from './modules/ink-density/InkDensityReadingPage.jsx';
import { InkDensityComparisonsPage } from './modules/ink-density/InkDensityComparisonsPage.jsx';
import { ComparisonPage } from './modules/ink-density/ComparisonPage.jsx';
import { UsersPage } from './modules/users/UsersPage.jsx';
import { ShiftsIndexPage } from './modules/shifts/ShiftsIndexPage.jsx';
import { JobsIndexPage } from './modules/jobs/JobsIndexPage.jsx';
import { JobDetailPage } from './modules/jobs/JobDetailPage.jsx';
import { StubPage } from './components/StubPage.jsx';

const Protected = ({ children }) => (
  <RequireAuth>
    <Layout>{children}</Layout>
  </RequireAuth>
);

export const App = () => (
  <LocationProvider>
    <AuthProvider>
      <Router>
        <Route path="/login" component={LoginPage} />

        <Route path="/" component={() => <Protected><LauncherPage /></Protected>} />
        <Route path="/inventory" component={() => <Protected><InventoryIndexPage /></Protected>} />
        <Route path="/inventory/:id" component={({ id }) => <Protected><InventoryItemDetailPage id={id} /></Protected>} />
        <Route path="/ink-books" component={() => <Protected><InkBooksIndexPage /></Protected>} />
        <Route path="/ink-books/:bookId" component={({ bookId }) => <Protected><BookDetailPage bookId={bookId} /></Protected>} />
        <Route path="/ink-books/:bookId/inks/:inkId" component={({ bookId, inkId }) => <Protected><InkDetailPage bookId={bookId} inkId={inkId} /></Protected>} />
        <Route path="/converter" component={() => <Protected><ConverterPage /></Protected>} />
        <Route path="/printers" component={() => <Protected><PrintersIndexPage /></Protected>} />
        <Route path="/printers/:id" component={({ id }) => <Protected><PrinterDetailPage id={id} /></Protected>} />
        <Route path="/equipment" component={() => <Protected><EquipmentPage /></Protected>} />
        <Route path="/machines" component={() => <Protected><MachinesPage /></Protected>} />
        <Route path="/maintenance" component={() => <Protected><MaintenanceIndexPage /></Protected>} />
        <Route path="/maintenance/issues/:id" component={({ id }) => <Protected><IssueDetailPage id={id} /></Protected>} />
        <Route path="/maintenance/events/:id" component={({ id }) => <Protected><EventDetailPage id={id} /></Protected>} />
        <Route path="/contacts" component={() => <Protected><ContactsPage /></Protected>} />
        <Route path="/statistics" component={() => <Protected><StatisticsPage /></Protected>} />
        <Route path="/ink-density" component={() => <Protected><InkDensityIndexPage /></Protected>} />
        <Route path="/ink-density/comparisons" component={() => <Protected><InkDensityComparisonsPage /></Protected>} />
        <Route path="/ink-density/comparisons/:id" component={({ id }) => <Protected><ComparisonPage id={id} /></Protected>} />
        <Route path="/ink-density/:id" component={({ id }) => <Protected><InkDensityReadingPage id={id} /></Protected>} />
        <Route path="/customer-profiles" component={() => <Protected><CustomerProfilesPage /></Protected>} />
        <Route path="/customers" component={() => <Protected><CustomersPage /></Protected>} />
        <Route path="/admin" component={() => <Protected><UsersPage /></Protected>} />
        <Route path="/shifts" component={() => <Protected><ShiftsIndexPage /></Protected>} />
        <Route path="/jobs" component={() => <Protected><JobsIndexPage /></Protected>} />
        <Route path="/jobs/:id" component={({ id }) => <Protected><JobDetailPage id={id} /></Protected>} />

        <Route default component={() => <Protected><StubPage name="404" description="Route not found." /></Protected>} />
      </Router>
    </AuthProvider>
  </LocationProvider>
);
